export default __webpack_public_path__ + "static/O0209-e4bffe2f5a5d62e83f0228c707e6df60.png";